import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';

import { QuizContext } from '../../../store/quiz';
import { media } from '../../../utils/styles';

export const Landing = ({ heading, text }) => {
  const {
    store: { submitAnswer, quizLog, quizUid },
  } = useContext(QuizContext);

  useEffect(() => {
    quizLog('Load', 'Gender');
    // eslint-disable-next-line
  }, []);

  const onSubmit = (question, answer) => {
    submitAnswer(question, answer);
    quizLog(`Answer_${answer}`, question);
  };

  return (
    <Wrap>
      <Heading>{heading}</Heading>
      <Text>{text}</Text>
      <CtaHeading>Select your gender:</CtaHeading>
      <Buttons>
        <Button $color="#6BBD9A" type="button" onClick={() => onSubmit('gender', 'male')}>
          Male
        </Button>
        <Button $color="#FF6B6B" type="button" onClick={() => onSubmit('gender', 'female')}>
          Female
        </Button>
      </Buttons>
      {quizUid === 'hypertension-and-cholesterol' && (
        <Footer>
          <p>© 2021 Heartio.health. All rights reserved.</p>
          <p>Disclaimer: Results may vary from person to person.</p>
          <p>Support: hello@heartio.health, +1 (928) 582-7692</p>
        </Footer>
      )}
    </Wrap>
  );
};

const Footer = styled.div`
  font-size: 11px;
  line-height: 21px;
  width: 686px;
  max-width: 100%;
  margin: 0 auto;
  color: #868585;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 24px;
  ${media.phone} {
    font-size: 10px;
    line-height: 18px;
    position: static;
    margin-top: auto;
  }
`;

const Buttons = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: 162px 162px;
  grid-column-gap: 24px;
  width: 100%;
  ${media.phone} {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 12px;
    margin-bottom: 60px;
  }
`;

const Button = styled.button`
  height: 58px;
  width: 100%;
  border-radius: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  background: ${p => p.$color};
  transition: 0.3s ease-out opacity;
  &:hover {
    opacity: 0.7;
  }
`;

const Wrap = styled.div`
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${media.phone} {
    padding-top: 40px;
  }
`;

const Heading = styled.h1`
  font-weight: bold;
  font-size: 32px;
  line-height: 43px;
  text-transform: capitalize;
  width: 488px;
  max-width: 100%;
  margin: 0 auto 16px;
  ${media.phone} {
    font-size: 28px;
    line-height: 36px;
  }
`;

const CtaHeading = styled.h2`
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  margin: 0 0 24px;
`;

const Text = styled.p`
  margin: 0 auto 48px;
  font-size: 16px;
  line-height: 28px;
  color: #5c5c5c;
  width: 400px;
  max-width: 100%;
  ${media.phone} {
    margin: 0 auto 24px;
  }
`;
